import React, { useState } from 'react';

export default function QuickCreateModal({ projects, schedules, onSubmit, onClose }) {
  var fs = useState({ project: '', roomName: '', roomNumber: '', schedule: '', item: '', tag: '' });
  var form = fs[0];
  var setForm = fs[1];

  var qcProject = (projects || []).find(function(pr) { return pr.label === form.project; });
  var qcRooms = qcProject ? (qcProject.rooms || []) : [];
  var qcFiltered = qcRooms.filter(function(r) {
    return !form.roomName || r.name.toLowerCase().indexOf(form.roomName.toLowerCase()) >= 0;
  });
  var canSubmit = form.project && form.roomName && form.roomNumber && form.schedule && form.item.trim();

  function handleSubmit() {
    if (!canSubmit) return;
    onSubmit({
      project:    form.project,
      roomName:   form.roomName,
      roomNumber: form.roomNumber,
      schedule:   form.schedule,
      item:       form.item.trim(),
      tag:        form.tag || '',
    });
  }

  var labelStyle = {
    fontSize: 9, fontWeight: 500, color: '#888880',
    letterSpacing: '0.08em', textTransform: 'uppercase',
    display: 'block', marginBottom: 5,
  };
  var inputStyle = {
    height: 34, width: '100%', border: '0.5px solid #D8D7D2',
    borderRadius: 5, padding: '0 10px', fontSize: 12,
    fontFamily: 'inherit', color: '#111111', background: '#FFFFFF',
    outline: 'none', boxSizing: 'border-box',
  };
  var selectStyle = {
    height: 34, width: '100%', border: '0.5px solid #D8D7D2',
    borderRadius: 5, padding: '0 10px', fontSize: 12,
    fontFamily: 'inherit', color: '#111111', background: '#FFFFFF',
  };

  return (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      onClick={onClose}>
      <div
        style={{ background: '#FFFFFF', borderRadius: 8, border: '0.5px solid #D8D7D2', width: 440, maxWidth: '92vw', overflow: 'hidden' }}
        onClick={function(e) { e.stopPropagation(); }}>

        <div style={{ display: 'flex', alignItems: 'center', height: 46, padding: '0 16px', borderBottom: '0.5px solid #D8D7D2' }}>
          <span style={{ fontSize: 14, fontWeight: 500, flex: 1 }}>New item</span>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 16, cursor: 'pointer', color: '#888880', fontFamily: 'inherit' }}>✕</button>
        </div>

        <div style={{ padding: '20px 16px' }}>

          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Project <span style={{ color: '#D4007A' }}>*</span></label>
            <select
              value={form.project}
              onChange={function(e) {
                setForm(function(prev) { return Object.assign({}, prev, { project: e.target.value, roomName: '', roomNumber: '' }); });
              }}
              style={selectStyle}>
              <option value=''>— Select project —</option>
              {(projects || []).map(function(pr) {
                return <option key={pr.id || pr.label} value={pr.label}>{pr.label}</option>;
              })}
            </select>
          </div>

          <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
            <div style={{ flex: 2, position: 'relative' }}>
              <label style={labelStyle}>Room <span style={{ color: '#D4007A' }}>*</span></label>
              <input
                value={form.roomName}
                onChange={function(e) {
                  var val = e.target.value;
                  var exact = qcRooms.find(function(r) { return r.name.toLowerCase() === val.toLowerCase(); });
                  setForm(function(prev) { return Object.assign({}, prev, { roomName: val, roomNumber: exact ? exact.number : prev.roomNumber }); });
                }}
                placeholder='Type to search rooms…'
                style={inputStyle}
              />
              {form.roomName && qcFiltered.length > 0 && !qcRooms.find(function(r) { return r.name.toLowerCase() === form.roomName.toLowerCase(); }) && (
                <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#FFFFFF', border: '0.5px solid #D8D7D2', borderRadius: 5, zIndex: 100, maxHeight: 180, overflowY: 'auto', marginTop: 2 }}>
                  {qcFiltered.map(function(r, i) {
                    return (
                      <div key={i}
                        onMouseDown={function() { setForm(function(prev) { return Object.assign({}, prev, { roomName: r.name, roomNumber: r.number }); }); }}
                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 12px', fontSize: 12, cursor: 'pointer', borderBottom: '0.5px solid #EFEFEC', fontFamily: 'inherit' }}>
                        <span>{r.name}</span>
                        <span style={{ fontSize: 10, color: '#888880', fontWeight: 500 }}>{r.number}</span>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div style={{ flex: '0 0 100px' }}>
              <label style={labelStyle}>Tag</label>
              <input
                value={form.tag}
                onChange={function(e) { setForm(function(prev) { return Object.assign({}, prev, { tag: e.target.value }); }); }}
                placeholder='e.g. L01-101'
                style={inputStyle}
              />
            </div>
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Schedule type <span style={{ color: '#D4007A' }}>*</span></label>
            <select
              value={form.schedule}
              onChange={function(e) { setForm(function(prev) { return Object.assign({}, prev, { schedule: e.target.value }); }); }}
              style={selectStyle}>
              <option value=''>— Select schedule —</option>
              {(schedules || []).map(function(s) { return <option key={s} value={s}>{s}</option>; })}
            </select>
          </div>

          <div style={{ marginBottom: 0 }}>
            <label style={labelStyle}>Item description <span style={{ color: '#D4007A' }}>*</span></label>
            <input
              value={form.item}
              onChange={function(e) { setForm(function(prev) { return Object.assign({}, prev, { item: e.target.value }); }); }}
              onKeyDown={function(e) { if (e.key === 'Enter' && canSubmit) handleSubmit(); }}
              placeholder='e.g. DINING CHAIR'
              style={inputStyle}
            />
            <div style={{ fontSize: 10, color: '#888880', marginTop: 4 }}>Press Enter or click Continue when ready</div>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 16px', borderTop: '0.5px solid #D8D7D2' }}>
          <button
            onClick={onClose}
            style={{ height: 30, padding: '0 12px', borderRadius: 5, border: '0.5px solid #D8D7D2', background: '#FFFFFF', cursor: 'pointer', fontSize: 11, fontWeight: 500, color: '#111111', fontFamily: 'inherit' }}>
            Cancel
          </button>
          <div style={{ flex: 1 }} />
          <button
            onClick={handleSubmit}
            disabled={!canSubmit}
            style={{ height: 30, padding: '0 14px', borderRadius: 5, border: '0.5px solid #111111', background: canSubmit ? '#111111' : '#D8D7D2', color: '#FFFFFF', cursor: canSubmit ? 'pointer' : 'not-allowed', fontSize: 11, fontWeight: 500, fontFamily: 'inherit' }}>
            Continue →
          </button>
        </div>
      </div>
    </div>
  );
}
